import { RefObject, useEffect, useMemo } from 'react';

type MutationCallback = (
  mutations: MutationRecord[],
  observer: MutationObserver
) => void;

interface MutationObserverOptions extends MutationObserverInit {
  attributes?: boolean;
  childList?: boolean;
  subtree?: boolean;
}

export function useMutationObserver({
  ref,
  onMutation,
  options,
}: {
  ref: RefObject<HTMLElement>;
  onMutation: MutationCallback;
  options?: MutationObserverOptions;
}): void {
  const opts = useMemo(
    () => ({
      attributes: true,
      childList: true,
      subtree: false,
      ...options,
    }),
    [options]
  );

  useEffect(() => {
    if (!ref.current) return;

    const observer = new MutationObserver(onMutation);

    observer.observe(ref.current, opts);

    return () => observer.disconnect();
  }, [opts, onMutation]);
}
